import { create } from "zustand";

interface ModalState {
  connectWalletModalOpen: boolean;
  setConnectWalletModalOpen: (open: boolean) => void;
}

const useModalStore = create<ModalState>((set) => ({
  connectWalletModalOpen: false,
  setConnectWalletModalOpen: (open) => set({ connectWalletModalOpen: open }),
}));

export default useModalStore;
